import { render } from "./SupplementaryReportView.vue?vue&type=template&id=a1df54c8&scoped=true"
import script from "./SupplementaryReportView.vue?vue&type=script&lang=js"
export * from "./SupplementaryReportView.vue?vue&type=script&lang=js"

import "./SupplementaryReportView.vue?vue&type=style&index=0&id=a1df54c8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1df54c8"],['__file',"src/components/cases/SupplementaryReportView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1df54c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1df54c8', __exports__)) {
    console.log('reload')
    api.reload('a1df54c8', __exports__)
  }
  
  module.hot.accept("./SupplementaryReportView.vue?vue&type=template&id=a1df54c8&scoped=true", () => {
    console.log('re-render')
    api.rerender('a1df54c8', render)
  })

}


export default __exports__